import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Attach token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hsps_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error.response?.status === 401) {
      // Don't auto-redirect for /auth/me checks; let the AuthContext handle it
    }
    return Promise.reject(error);
  }
);

export default api;
